import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FullPageProps } from './interface';
import './styles.scss';

function FullPage({ children }: FullPageProps) {
    const { ready } = useTranslation();
    const [pageReady, setPageReady] = useState(false);

    useEffect(() => {
        if (ready) {
            setTimeout(() => {
                setPageReady(true);
            }, 0);
        }
    }, [ready]);

    if (!pageReady) return <div>Loading...</div>;

    return children as JSX.Element;
}

export default FullPage;
